import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row g-4 mb-4" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "row g-4 mb-4" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "row g-4 mb-4" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "row g-4 mb-4" }
const _hoisted_12 = { class: "col-lg-3" }
const _hoisted_13 = { class: "col-lg-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeRealEstateAgent = _resolveComponent("WelcomeRealEstateAgent")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_TotalRevenueChart = _resolveComponent("TotalRevenueChart")!
  const _component_TopChannels = _resolveComponent("TopChannels")!
  const _component_RecentClients = _resolveComponent("RecentClients")!
  const _component_MyFeaturedListings = _resolveComponent("MyFeaturedListings")!
  const _component_RevenueGoalProgress = _resolveComponent("RevenueGoalProgress")!
  const _component_SalesByCountry = _resolveComponent("SalesByCountry")!
  const _component_DownloadApp = _resolveComponent("DownloadApp")!
  const _component_LatestTransactions = _resolveComponent("LatestTransactions")!
  const _component_ClientRatings = _resolveComponent("ClientRatings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WelcomeRealEstateAgent),
    _createVNode(_component_Stats),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TotalRevenueChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TopChannels)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_RecentClients)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_MyFeaturedListings)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_RevenueGoalProgress)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_SalesByCountry)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_DownloadApp)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_LatestTransactions)
      ])
    ]),
    _createVNode(_component_ClientRatings)
  ]))
}